import { render, staticRenderFns } from "./VoteDialog.vue?vue&type=template&id=788240a2"
import script from "./VoteDialog.vue?vue&type=script&lang=js"
export * from "./VoteDialog.vue?vue&type=script&lang=js"
import style0 from "./VoteDialog.vue?vue&type=style&index=0&id=788240a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports